<template>
  <div>
    <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加分组' }" v-has="'btn_add'"  > 添加分组
    </a-button>
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">

      <span slot="action" slot-scope="text, record" >
              <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>

        <a @click="(record)=>{visibleForm = true; titleForm='修改分组'; editId=text.id ; }" v-has="'btn_edit'">编辑</a>
              <a-divider type="vertical"/>
          <a-popconfirm
              title="此操作将永久删除, 是否继续?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="()=>{}"
          >
            <a v-has="'btn_delete'">删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <GroupForm :visible="visibleForm" :title="titleForm" :editId="editId"
              @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
  </div>

</template>

<script>
import API from "./api";
import GroupForm from "./components/groupForm"
import {removeById} from "@/utils/utils"
const columns = [
  {
    title: "分组名称",
    dataIndex: "name",
    width: "20%",
    ellipsis: true,
    key: "name"
  },
  {
    title: "操作",
    key: "action",
    width: "200px",
    scopedSlots: {customRender: "action"}
  }
];
export default {
  name: 'CustomTemplateGroup',
  data() {
    return {
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      jurisdictionId: null,
      visibleJurisdiction: false,
      data: [],
      columns,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomTemplateGroup/index"; //设置左侧导航2-2 active
  },
  components: {GroupForm},
  methods: {
    getList(page) {
      this.loading = true
      API.ACustomTemplate.GET_LIST(page || 1).then(res => {
        this.pagination.total = res.data.data.total
        this.pagination.pageSize = res.data.data.per_page
        this.pagination.current = res.data.data.current_page
        this.data = res.data.data.data
        this.loading = false
      })
    },
    confirm(row) {
      removeById( API.ACustomTemplate.DELE, [row.id]).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
  },
  mounted() {
    this.getList()
  }

}
</script>
